export default "__VITE_ASSET__EPrMrHbS__"